module.exports = __webpack_public_path__ + "static/media/banner.2dd1bc2a.jpeg";